/* eslint-disable @fx-ui/jdy-design/limit-specific-characters */

// 特殊符号
export const SPECIFIC_SYMBOL = {
    INFINITY: '∞',
    COMMAND: '⌘',
    RIGHT_ARROW: '→',
    LESS_OR_EQUAL: '≤',
    ZERO_WIDTH_NBSP_CHAR: '\ufeff',
    BULLET: '•', // 常表示无序列表
    MULTI_BULLET: '•••', // 常表示多选状态
    HYPHEN: '—', // 常表示连接关系（全角连字符）
    MULTI_HYPHEN: '--', // 常表示空状态（半角连字符）
    TILDE: '~' // 常用于分割时间区间
};
